import { Component } from 'preact'
import { ModulesContext } from '../../utils/globals'
import Phrase from '../../libs/translationsUtils/phrase'
import UserFlag from './Flag'
import { UserModel } from '../../server-middleware/userContext'

interface Props extends UserModel {
  size: 'S' | 'M'
}

export default class Dropdown extends Component<Props> {
  render (props: Props) {
    return (
      <ModulesContext.Consumer>
        {modules =>
          <li class='main-navigation--profile-link qa-header-profile-link'>
            <UserFlag {...props} />
            <div class='dropdown dropdown--profile qa-header-profile-dropdown is-hidden'>
              <span class='arrow is-hidden-S' />
              <div class='user flag '>
                <div class='user_data flag__body'>
                  <a href={`/members/user-${props.id}`} class='link--text qa-menu-username'><Phrase p='My profile' /></a>
                </div>
              </div>
              <ul class='list--menu'>

                <li class='list__item qa-menu-user-topics'>
                  <a
                    class='link--text'
                    href={`/search/activity/topics?userid=${props.id}`}
                  >
                    <span><Phrase p='Topic|Topics' count={{ c: props.topicsCount }} /></span>
                    <span class='counter'>{props.topicsCount}</span>
                  </a>
                </li>
                <li class='list__item qa-menu-user-reactions'>
                  <a
                    class='link--text'
                    href={`/search/activity/reactions?userid=${props.id}`}
                  >
                    <span><Phrase p='Reply|Replies' count={{ c: props.repliesCount }} /></span>
                    <span class='counter'>{props.repliesCount}</span>
                  </a>
                </li>
                <li class='list__item qa-menu-user-solved'>
                  <a
                    class='link--text'
                    href={`/search/activity/solved?userid=${props.id}`}
                  >
                    <span><Phrase p='Solved' count={{ c: props.solvedCount }} /></span>
                    <span class='counter'>{props.solvedCount}</span>
                  </a>
                </li>

                <li class='list__item qa-menu-favorites'>
                  <a class='link--text' href='/favorite/overview'>
                    <Phrase p='header.profile.dropdown.subscriptions' />
                  </a>
                </li>

                {modules.includes('privateMessage')
                  ? <li class='list__item qa-menu-private-messages'>
                    <a
                      class='link--text messages {% if App.user.person.pmunread > 0 %}counter-alert{% endif %}'
                      href='/inbox/overview'
                    >
                      <span><Phrase p='Private messages' /></span>
                      <span class='counter'>
                        {props.pmUnreadCount ? `${props.pmUnreadCount} /` : null}
                        {props.pmTotalCount}
                      </span>
                    </a>
                  </li>
                  : null}

                <li class='list__item list__item--border-top qa-menu-settings'>
                  <a class='link--text' href='/settings/profile'>
                    <Phrase p='Settings' />
                  </a>
                </li>

                <li class='list__item qa-menu-logout'>
                  <a class='link--text' href='/member/logout' onClick={() => sessionStorage.setItem('UserLoggedOut', 'true')}>
                    <Phrase p='Logout' />
                  </a>
                </li>
              </ul>
            </div>
          </li>}
      </ModulesContext.Consumer>
    )
  }
}
